export const dateFormatter = (date: string) => {
  return date.replaceAll("-", "/").split("/").reverse().join("/");
};